<template>
  <div
    v-if="is_admin"
    class=""
  >
    <v-text-field
      v-model="query"
      solo
      hide-details
      dense
      placeholder="search"
      class="search-box body-2"
      :style="searchBoxStyle"
      @keyup.enter="search"
    >
      <template #append>
        <v-btn
          icon
          small
          @click="search"
        >
          <v-icon color="black"> mdi-magnify </v-icon>
        </v-btn>
      </template>
      <template #append-outer>
        <v-select
          v-model="location"
          solo
          elevation="0"
          class="body-2 location-select"
          hide-details
          dense
          :items="locations"
          item-text="text"
          item-value="id"
          @keyup.enter="search"
        />
      </template>
    </v-text-field>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HeaderSearch',

  props: {},

  data: () => ({
    location: 'jobId',
    query: '',
    locations: [
      {
        id: 'user',
        text: 'User'
      },
      {
        id: 'jobId',
        text: 'Job Id'
      },
      {
        id: 'orderId',
        text: 'Order Id'
      }
      //   {
      //     id: "templateId",
      //     text: "Template Id"
      //   }
    ]
  }),

  computed: {
    searchBoxStyle() {
      return {
        width: this.$vuetify.breakpoint.mobile ? '300px' : '500px'
      };
    },
    ...mapGetters({ is_admin: 'auth/is_admin' })
  },

  methods: {
    search() {
      if (this.location === 'user') {
        this.searchUser();
      } else if (this.location === 'jobId') {
        this.searchJob();
      } else if (this.location === 'orderId') {
        this.searchOrder();
      } else if (this.location === 'templateId') {
        this.searchTemplate();
      }
    },

    searchUser() {
      this.$router.push(`/users?search=${this.query.trim()}`);
      this.$store.commit('config/REFRESH_CURRENT_ROUTE');
    },

    searchJob() {
      this.$http.get(`orders/getOrderIdForJob?jobId=${this.query.trim()}`).then((response) => {
        var orderId = response.data.orderId;
        if (orderId) {
          this.$store.commit('drawers/OPEN_DRAWER', this.$enums.DRAWERS.PRINT_JOB_DETAIL);
          this.$store.commit('drawers/SET_DATA', {
            drawerId: this.$enums.DRAWERS.PRINT_JOB_DETAIL,
            data: { orderId: orderId, jobId: parseInt(this.query.trim()) }
          });
        } else {
          this.$root.$alert('Job Not Found', 'Unable to find job id ' + this.query.trim());
        }
      });
    },

    searchOrder() {
      this.$router.push(`/orders/${this.query.trim()}`);
      this.$store.commit('config/REFRESH_CURRENT_ROUTE');
    },

    searchTemplate() {}
  }
};
</script>

<style scoped>
>>> .v-input__append-outer {
  margin-top: 0 !important;
  margin-left: 0 !important;
}
>>> .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
  border: solid 1px #d1d1d1;
}
.location-select {
  border-left: none;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  min-width: 120px !important;
  max-width: 120px !important;
}
.search-box {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
</style>
